let imsuppliertypes = [
  "Freight Forwarder",
  "Air Transportation",
  "Sea Transportation",
  "Land Transportation",
  "Custom Clearance",
  "Other",
];
export default imsuppliertypes;
